exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.input-switcher[data-v-458b7072] {\n  position: absolute;\n  /*bottom: -28px;*/\n  left: 20px;\n  font-size: 12px;\n  color: var(--primary-color);\n  cursor: pointer;\n}\n.bottom-spacing[data-v-458b7072] {\n  margin-bottom: 10px;\n}\n", ""]);

// exports
